import { createFileRoute } from "@tanstack/react-router"
import type { Cart } from "@/money"
import { Checkout } from "@/money"

export const Route = createFileRoute("/(user)/t/$tenantSlug/checkout")({
  component: RouteComponent,
  validateSearch: (search) =>
    search as {
      cart: Cart
      session?: string
    },
})

function RouteComponent() {
  const { session, cart } = Route.useSearch()

  return <Checkout cart={cart} sessionId={session} />
}
